import { useState } from "react";
import { Aviso, Abas, PainelDaAba } from "../componentes/ui";
import { PainelDeDuplicados } from "../componentes/cadastro/PainelDeDuplicados";
import { PainelDeImportacao } from "../componentes/cadastro/PainelDeImportacao";
import { PainelDeOrganizacoes } from "../componentes/cadastro/PainelDeOrganizacoes";
import { PainelDePessoas } from "../componentes/cadastro/PainelDePessoas";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "organizacoes" | "pessoas" | "importar" | "duplicados";

/** Cadastros: as empresas e as pessoas que a GEOvendas atende, com importação e fusão. */
export function Cadastros() {
  useTitulo("Cadastros");
  const sessao = useSessao();
  const [ativa, setAtiva] = useState<Aba>("organizacoes");

  if (!sessao.data) {
    return (
      <p className="lead" role="status">
        Verificando o seu acesso…
      </p>
    );
  }
  if (!podeNaSessao(sessao.data, "console:ver")) {
    return (
      <Aviso tom="marca" data-testid="cadastros-sem-permissao">
        Os cadastros são da equipe da GEOvendas.
      </Aviso>
    );
  }

  const importa = podeNaSessao(sessao.data, "cadastro:importar");
  const funde = podeNaSessao(sessao.data, "cadastro:fundir");
  const abas: Array<{ chave: Aba; rotulo: string }> = [
    { chave: "organizacoes", rotulo: "Organizações" },
    { chave: "pessoas", rotulo: "Pessoas" },
    ...(importa ? [{ chave: "importar" as const, rotulo: "Importar planilha" }] : []),
    ...(funde ? [{ chave: "duplicados" as const, rotulo: "Duplicados" }] : []),
  ];

  return (
    <div data-testid="cadastros">
      <h1 className="titulo-pagina">Cadastros</h1>
      <p className="lead mb-4">
        As empresas e as pessoas atendidas: dados, contatos, endereços, importação por planilha e
        fusão de duplicados.
      </p>
      <Abas<Aba> rotulo="Cadastros" id="cadastros" itens={abas} ativa={ativa} aoSelecionar={setAtiva} className="mb-4" />
      <PainelDaAba id="cadastros" chave="organizacoes" ativa={ativa} data-testid="painel-organizacoes">
        <PainelDeOrganizacoes />
      </PainelDaAba>
      <PainelDaAba id="cadastros" chave="pessoas" ativa={ativa} data-testid="painel-pessoas">
        <PainelDePessoas podeEditar={podeNaSessao(sessao.data, "usuarios:gerenciar")} />
      </PainelDaAba>
      {importa ? (
        <PainelDaAba id="cadastros" chave="importar" ativa={ativa} data-testid="painel-importar">
          <PainelDeImportacao />
        </PainelDaAba>
      ) : null}
      {funde ? (
        <PainelDaAba id="cadastros" chave="duplicados" ativa={ativa} data-testid="painel-duplicados">
          <PainelDeDuplicados />
        </PainelDaAba>
      ) : null}
    </div>
  );
}
